export default __webpack_public_path__ + "641e24b4df30a134e6fe5cbbd7cc2478.svg";